import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { DataOptionsTypes } from "../types";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";
import { DownArrow } from "shared-components/Components/CustomIcons/DownArrow/web";
import {
    ageOfTheProperty,
} from '../options';

export const AgeOfThePropertyFilter = () => {
    const { filters } = useFilters();
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();

    const handleRadioOnChange = (option: DataOptionsTypes) => {
        if (option.value !== -1) changeFilters({ antiquity: option });
        else changeFilters({ antiquity: null });
    }

    return (
        <div className="otherFilters__container" id="ageOfTheProperty">
            <input
                className="otherFilters__dropDownIsActive"
                type="checkbox"
                id="ageOfThePropertyDropdown"
            />
            <label
                className="otherFilters__dropDownSelector"
                htmlFor="ageOfThePropertyDropdown">
                Antiguedad del Inmueble
                <DownArrow />
            </label>
            
            <div className="otherFilters__dropdown">
                {ageOfTheProperty.map((val, i) => {
                    return (
                        <div
                            key={"age-property-filter - " + i}
                            className="otherFilters__container__option more-filters"
                        >
                            <input
                                type="radio"
                                className="radioCustomInput"
                                onChange={() => handleRadioOnChange(val)}
                                name={"age-property-filter"}
                                id={`age-property-${val.value}`}
                                value={val.value ?? ""}
                                defaultChecked={
                                    filters?.antiquity ?
                                        filters?.antiquity === val.value :
                                        val.value === -1
                                }
                            />
                            <label htmlFor={`age-property-${val.value}`}>{val.text}</label>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}